import { Toaster } from "react-hot-toast";
import Layout from "../shared/Layout";
import { useEffect, useState } from "react";
import { API_URL, baseurl } from "../../_config";
import axios from "axios";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const BookingSlot = () => {
    const navigate = useNavigate();
    const [error, setError] = useState();
    const [bookingData, setBookingData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);

    const fetchbookingData = async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.getSlotBooking}`);

            if (response?.data?.isSuccess === true) {
                setBookingData(response?.data?.data)
            }
        } catch (error) {
            setError("Error fetching menu data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchbookingData();
    }, []);

    useEffect(() => {
        if (searchTerm) {
            const filtered = bookingData.filter(item =>
                item.Name.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.MobileNo.toString().includes(searchTerm)
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(bookingData);
        }
    }, [searchTerm, bookingData]);

    const handleStatusChange = async (row, e) => {
        try {
            const response = await axios.post(`${baseurl}${API_URL?.updateBookingStatus}`, {
                loginId: row?.LoginId,
                bookingId: row?.BookingId,
                status: e.target.value,
                deviceToken: row?.DeviceToken
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 200) {
                toast.success("Booking status updated successfully.");
                fetchbookingData();
            }
        } catch (error) {
            toast.error("Error updating booking status. Please try again later.");
        }
    };

    const handleDelete = async (id) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this slot?");

        if (isConfirmed) {
            try {
                const response = await axios.post(`${baseurl}${API_URL?.deleteSlotBooking}`, {
                    id: id
                }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                if (response?.data?.isSuccess === true) {
                    toast.success("Slot Deleted Successfully");
                    fetchbookingData();
                }
            } catch (error) {
                toast.error("Please try again later.");
            }
        }
    };

    const onBookingDetailByLoginId = (row) => {
        navigate(`/booking-detail/${row?.LoginId}`);
    }

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '60px',
        },
        {
            name: 'Name',
            selector: row => (
                <div>
                    {row.firstName} {row.lastName}
                </div>
            ),
            sortable: true,
            minWidth: '150px'
        },
        {
            name: 'Email Id',
            selector: row => (
                <div className="booking_data curser-pointer" onClick={() => onBookingDetailByLoginId(row)}>
                    <h6>{row.emailId}</h6>
                    <span>{row?.contactNumber}</span>
                </div>
            ),
            sortable: true,
            minWidth: '300px'
        },
        {
            name: 'Appoiment Date',
            selector: row => {
                if (row.SlotDate) {
                    const date = new Date(row.SlotDate);

                    const indianTime = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));

                    const day = String(indianTime.getDate()).padStart(2, '0');
                    const month = String(indianTime.getMonth() + 1).padStart(2, '0');
                    const year = indianTime.getFullYear();

                    return `${day}/${month}/${year}`;
                } else {
                    return 'N/A';
                }
            },
            sortable: false,
            minWidth: '130px'
        },
        {
            name: 'Action',
            cell: row => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    <span onClick={() => handleDelete(row?.id)} title='Delete' className="delete_icon_weepr">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                        </svg>
                    </span>
                </div>
            ),
            sortable: false
        }
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="right-content-section">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Booked Slot</h4>
                    </div>
                </div>
                {error ? (
                    <p>Data not avaiable</p>
                ) : (
                    <div className="datatable mt-4">
                        <DataTable
                            columns={columns}
                            data={filteredData || []}
                            progressPending={loading}
                            progressComponent={<p>Loading...</p>}
                            pagination
                            highlightOnHover
                        />
                    </div>
                )}
            </div>
        </Layout>
    )
}

export default BookingSlot;